import { parameterService } from '../../../services';
import { encode } from 'querystring';

export default async function checkIsCityNameHaveBranch(provinceIsocode, cityName) {
  const params = new URLSearchParams(
    encode({
      isOnlyHaveBranch: true,
    })
  );
  const res = await parameterService.getListCity(provinceIsocode, params);
  const cityHaveBranchList = res.data;
  const cityDetail = cityHaveBranchList.find((item) => item.name === cityName);
  const isCityHaveBranch = cityDetail !== undefined;

  return {
    isCityHaveBranch,
    cityDetail,
    cityList: cityHaveBranchList,
  };
}
